import AssessmentType from "./assessment-type";

export default class AssessmentRole {
  lookupCode: string;
  lookupValue: string;
  types: AssessmentType[];

  constructor(lookupCode: string, lookupValue: string) {
    this.lookupCode = lookupCode;
    this.lookupValue = lookupValue;
    this.types = [];
  }

  addType(assessmentType: AssessmentType): void {
    let f = this.types.filter(
      (x) => x.lookupCode === assessmentType.lookupCode
    );
    if (f.length > 0) return;

    // console.log("Adding type");
    // console.log(assessmentType);
    this.types.push(assessmentType);
  }
}



// WEBPACK FOOTER //
// ./src/models/assessment/assessment-role.ts